"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EgressTeamMessageSchema = exports.EgressCampaignMessageSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.EgressCampaignMessageSchema = (0, core_1.StrictObject)({
    // The range to export
    from: core_1.TimestampSchema,
    to: core_1.TimestampSchema,
    campaign: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
        channelType: ruby_1.ChannelTypeSchema,
    }),
    tier: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
    }),
    team: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
    }),
});
exports.EgressTeamMessageSchema = (0, core_1.StrictObject)({
    // The range to export
    from: core_1.TimestampSchema,
    to: core_1.TimestampSchema,
    tier: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
    }),
    team: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
    }),
    campaigns: typebox_1.Type.Array((0, core_1.StrictObject)({
        id: core_1.IdSchema,
        channelType: ruby_1.ChannelTypeSchema,
    })),
});
